import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import Fab from "@material-ui/core/Fab"
import Grid from "@material-ui/core/Grid"
import IconButton from "@material-ui/core/IconButton"
import AddIcon from "@material-ui/icons/Add"
import CloseIcon from "@material-ui/icons/Close"
import PublishIcon from "@material-ui/icons/Publish"
import {range} from "lodash"
import React, {useState} from "react"
import {Trans, useTranslation} from "react-i18next"
import {connect} from "react-redux"
import {IntroSection, RadioGroup, TitleSection, UploadForm} from "~/components/"
import history from "~/history.js"
import {ProductList} from "./list/ProductList"

const introImage = require("~/images/ProductView Intro.svg")

const ProductsView = props => {
  const CONDITIONS_UPLOAD = "conditions_upload"
  const PRODUCTS_UPLOAD = "products_upload"

  const {t} = useTranslation()

  const items = [
    {label: t("products.import.uploadConditions"), value: CONDITIONS_UPLOAD},
    {label: t("products.import.uploadProduct"), value: PRODUCTS_UPLOAD}
  ]

  const [open, setOpen] = useState(false)
  const [uploading, setOnUpload] = useState(false)
  const [selectedImport, setSelectedImport] = useState(CONDITIONS_UPLOAD)

  function handleClose() {
    if (!uploading) {
      setOpen(false)
    }
  }

  return (
    <React.Fragment>
      <TitleSection
        style={{
          display: "flex",
          justifyContent: "space-between"
        }}
      >
        <Box display="flex" flex={1}>
          <Box flex={1}>
            <h3>{t("products.title")}</h3>
          </Box>
          <Box maxWidth={600}>
            <Grid
              container
              justifyContent="flex-end"
              alignItems="center"
              spacing={2}
            >
              {!!props.superAdmin && (
                <Grid item>
                  <Button
                    color="primary"
                    variant="text"
                    startIcon={<PublishIcon />}
                    onClick={() => setOpen(true)}
                  >
                    {t("products.import.title")}
                  </Button>
                </Grid>
              )}
              {(!!props.admin || !!props.tenantAdmin) && (
                <Grid item>
                  <Fab
                    variant="extended"
                    color="primary"
                    onClick={() => history.push("/products/new")}
                    aria-label="add-product"
                    size="medium"
                  >
                    <AddIcon />
                    {t("products.new")}
                  </Fab>
                </Grid>
              )}
              <Grid item>
                <Fab
                  variant="extended"
                  color="primary"
                  aria-label="add-zone"
                  size="medium"
                  onClick={() => history.push("/areas/new")}
                >
                  <AddIcon />
                  {t("products.newZone")}
                </Fab>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </TitleSection>

      <IntroSection image={introImage}>
        <p>
          <Trans i18nKey="products.intro">
            <strong>Ein Artikelstamm</strong> enthält grundsätzliche
            Informationen über einen Lagerartikeltyp. Die{" "}
            <strong>Lagerartikel</strong>, welche schliesslich im Warenlager
            verwaltet werden, sind jeweils mit einem solchen Artikelstamm
            verknüpft.
          </Trans>
        </p>
      </IntroSection>

      <ProductList
        disableProductActions={!props.admin || !props.tenantAdmin}
        {...props}
      />
      {!!props.admin && (
        <React.Fragment>
          <Dialog
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={open}
            fullWidth
          >
            <DialogTitle id="simple-dialog-title" variant="h2">
              <Box
                display="flex"
                justifyContent="space-between"
                alignContent="center"
                alignItems="center"
              >
                <div>{t("products.import.title")}</div>
                <IconButton
                  alignSelf="flex-end"
                  aria-label="close"
                  disabled={!!uploading}
                  onClick={handleClose}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <RadioGroup
              disabled={!!uploading}
              title={t("products.import.selection")}
              defaultValue={selectedImport}
              onChange={setSelectedImport}
              items={items}
            />
            {selectedImport === PRODUCTS_UPLOAD && (
              <UploadForm
                type="product"
                label={t("products.import.uploadProductRegion")}
                allowedFileTypes={[{value: "text/csv", label: "csv"}]}
                onUpload={setOnUpload}
              />
            )}
            {selectedImport === CONDITIONS_UPLOAD && (
              <UploadForm
                onUpload={setOnUpload}
                type="condition"
                label={t("products.import.uploadConditionsForTenant")}
                allowedFileTypes={[
                  {
                    value:
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    label: "xlsx"
                  },
                  {
                    value: "application/vnd.ms-excel",
                    label: "xls"
                  }
                ]}
              />
            )}
          </Dialog>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

const yearOptions = range(-5).map(index => {
  const year = new Date().getFullYear() + index
  return {
    name: year,
    id: year
  }
})

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {admin, tenantAdmin, superAdmin} = user
  return {
    admin,
    superAdmin,
    tenantAdmin
  }
}

export default connect(mapStateToProps)(ProductsView)



// WEBPACK FOOTER //
// ./src/views/ProductsView.js